import { render, staticRenderFns } from "./Shanghu.vue?vue&type=template&id=d6276cca&"
import script from "./Shanghu.vue?vue&type=script&lang=js&"
export * from "./Shanghu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports